import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { IMaskInput } from 'react-imask';
import axiosInstance from 'services/axiosInstance';
import * as S from './styled';
//Components
import { useEffect } from 'react';
import LayoutModal from '../../../LayoutModal';
import Loading from "../../../Loading";
//hooks 
import apiRequest from '../../../../hooks/apiRequest';
import useLoading from "../../../../hooks/useLoading";
//Interfaces
import { ICreate } from 'Interfaces/ICreate';
import { Inputs } from 'Interfaces/ISupllier';
export default function Update({
  isOpenModal,
  setModalClose,
  refreshFrames,
  selectedUrlId,
  setToastData,
  setToastOpen
}: ICreate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();

  const fetchData = async () => {
    startLoading();
    try {
      const response = await axiosInstance.get(`supplier/${selectedUrlId}`);
      const addressData = response.data;
      for (const key in addressData) {
        setValue(key as keyof Inputs, addressData[key]);
      }
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (selectedUrlId !== null) {
      fetchData();
    }
  }, [selectedUrlId]);


  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const formattedData = {
        ...data,
        name: data.name.toUpperCase(),
      };

      const response = await apiRequest(`supplier/${selectedUrlId}`, 'PUT', formattedData);
      const status = response.status;
      if (status === 200) {
        setToastData({
          status: status,
          message: 'Cadastrado com sucesso!',
        });

        setToastOpen(true);
        refreshFrames();
        setModalClose();
      }
    } catch (error: any) {
      console.log('resposta: ', error);

      setToastData({
        status: error?.response?.status || 500,
        message: error.message || 'Erro inesperado',
      });

      setToastOpen(true);
    } finally {
      stopLoading();
    }
  };

  if (isOpenModal) {
    return (
      <LayoutModal
        statusLoad={isLoading}
        title="Atualizar Fornecedor"
        subTitle="Atualize informações do fornecedor em sua base de dados."
        setModalClose={setModalClose}
        submiteModal={handleFormSubmit(onSubmit)}
        nameSubmit="Atualizar"

        nameIconMinimize={'Atualizar Fornecedor'}
      >
        {
          isLoading ? (
            <Loading />
          ) :
            <S.Container>
              <S.FormInput>
                <S.Label>
                  Nome do Fornecedor
                  <span>*</span>
                </S.Label>
                <S.Input
                  placeholder="Informe o fornecedor"
                  type="text"
                  {...register("name", { required: true })}
                />
                {errors.name && <S.InforErro>Campo Obrigatório</S.InforErro>}
              </S.FormInput>

              <S.FormInput>
                <S.Label>Contato</S.Label>
                <Controller
                  name="contact"
                  control={control}
                  render={({ field }) => (
                    <IMaskInput
                      className="imask"
                      id="phone_primary"
                      mask="(00) 00000-0000"
                      placeholder="(99) 99999-9999"
                      {...field}
                    />
                  )}
                />
              </S.FormInput>

              <S.FormInput>
                <S.Label>E-mail</S.Label>
                <S.Input
                  placeholder="exemplo@gmail.com"
                  type="email"
                  {...register("email")}
                />
              </S.FormInput>

              <S.FormInput>
                <S.Label>Descrição</S.Label>
                <S.TextArea
                  placeholder="Campo Opcional"
                  rows={2}
                  {...register("description")}
                />
              </S.FormInput>
            </S.Container>
        }

      </LayoutModal>
    );
  }
  return null;
}